import {AgentSchema} from '../../agent';
import {AiFieldDefinitionSchema} from '../../enrichment';
import {AgentLabel} from '../../validation';
import {ObjectIdSchema} from '../../zod';
import {ApiDefinition} from '../definitions';
import {z} from 'zod';

export const SaveAgent = {
  path: 'agent/saveAgent',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    agent: AgentSchema.omit({timestamp: true}).partial({id: true}),
  }),
  responseDataSchema: AgentSchema,
} satisfies ApiDefinition;

export const PublishAgent = {
  path: 'agent/publishAgent',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    agentId: ObjectIdSchema,
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const DeleteAgent = {
  path: 'agent/deleteAgent',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    agentId: ObjectIdSchema,
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const CloneAgent = {
  path: 'agent/cloneAgent',
  method: 'post',
  options: {access: 'admin'},
  requestDataSchema: z.object({
    agentId: ObjectIdSchema,
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const GenerateAnalystAgent = {
  path: 'agent/generateAnalystAgent',
  method: 'post',
  options: {access: 'admin'},
  requestDataSchema: z.object({
    userQuestion: z.string(),
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const GenerateSegmentationAgent = {
  path: 'agent/generateSegmentationAgent',
  method: 'post',
  options: {access: 'admin'},
  requestDataSchema: z.object({
    agentLabel: z
      .string()
      .min(AgentLabel.minLength)
      .max(AgentLabel.maxLength)
      .regex(AgentLabel.pattern),
    domain: z.string(),
    testListId: ObjectIdSchema,
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const DownloadPrompts = {
  path: 'agent/downloadPrompts',
  method: 'get',
  options: {access: 'admin'},
  requestDataSchema: z.object({
    agentId: ObjectIdSchema,
    fieldDefinition: AiFieldDefinitionSchema,
  }),
  responseDataSchema: z
    .object({
      accountDomain: z.string(),
      prompt: z.string(),
    })
    .array(),
} satisfies ApiDefinition;
